import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fontSmall margin5px" }, " 入力したURLのドライブのフォルダに含まれるスマートテンプレートを集計します ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "fontRed"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "driveURL" }, " Google Drive URL : ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_openBlock(), _createBlock(_component_AppContent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _hoisted_2,
        (!_ctx.isValid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "※正しいGoogle Drive URLの形式ではありません"))
          : _createCommentVNode("", true),
        _hoisted_4,
        _createElementVNode("input", {
          style: {"width":"70%"},
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isValid = true)),
          class: _normalizeClass({ bkRed: !_ctx.isValid }),
          type: "url",
          id: "driveURL"
        }, null, 34)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _ctx.setParam,
          type: "fill"
        }, {
          default: _withCtx(() => [
            _createTextVNode("次へ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}